import { FunctionComponent, useEffect, useState } from 'react'
import { Alert, Spinner } from 'react-bootstrap'

import Page from 'components/ui/page'
import PageHeader from 'components/ui/pageHeader'
import * as userApi from 'features/user/api.client'
import { User } from 'features/user/signUp/types'
import { getUserProfile } from 'features/user/auth'
import { UserRole } from 'features/user/types'
import ProfileSection from './components/profileSection'
import PasswordSection from './components/passwordSection'
import DeleteAccountSection from './components/deleteAccountSection'
import accountCss from './account.module.scss'

const Account: FunctionComponent = () => {
  const role = getUserProfile()
  const [user, setUser] = useState<User | null>(null)
  const [loadError, setLoadError] = useState(false)

  useEffect(() => {
    userApi
      .get()
      .then(setUser)
      .catch(() => setLoadError(true))
  }, [])

  // The delete section sits at the bottom of the page (administrators don't have it).
  const canDelete = role !== UserRole.ADMIN

  return (
    <Page className={canDelete ? accountCss.pageFill : undefined}>
      <PageHeader title="Minha conta" />

      {loadError && <Alert variant="danger">Erro ao carregar os dados da conta.</Alert>}

      {!user && !loadError && (
        <div className={`card ${accountCss.loading}`}>
          <Spinner animation="border" size="sm" />
        </div>
      )}

      {user && (
        <div className="card">
          <ProfileSection
            initialName={user.name}
            initialEmail={user.email}
            isDoctor={role === UserRole.DOCTOR}
          />
          <PasswordSection />
          {/* The backend does not let administrators delete their own account. */}
          {canDelete && <DeleteAccountSection />}
        </div>
      )}
    </Page>
  )
}

export default Account
